export default "__VITE_ASSET__6452f1fb__"